module.exports = __webpack_public_path__ + "img/accept-terms-rafiki.455dd090.svg";